
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-calculator-line',
      title: 'Contabilidad de Nómina',
      description: 'Servicios integrales de contabilidad de nómina incluyendo cálculos salariales, retenciones fiscales, deducciones de beneficios y reportes detallados.',
      image: 'https://public.readdy.ai/ai/img_res/570ff21a9d8e239a3395c736cefc1996.jpg'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Contabilidad de Costos',
      description: 'Análisis detallado de costos y seguimiento para ayudarle a entender los gastos y rentabilidad de su negocio.',
      image: 'https://readdy.ai/api/search-image?query=Cost%20accounting%20analysis%20with%20Spanish%20charts%2C%20graphs%2C%20financial%20reports%20spread%20on%20desk%2C%20calculator%2C%20computer%20displaying%20cost%20analysis%20software%2C%20professional%20office%20environment%2C%20organized%20workspace%2C%20blue%20and%20white%20theme%2C%20simple%20clean%20background&width=400&height=300&seq=es-cost-accounting&orientation=landscape'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Procesamiento AP/AR',
      description: 'Gestión de Cuentas por Pagar y por Cobrar para mantener su flujo de efectivo optimizado y organizado.',
      image: 'https://readdy.ai/api/search-image?query=Spanish%20accounts%20payable%20and%20receivable%20processing%20setup%20with%20invoices%2C%20payment%20records%2C%20computer%20showing%20accounting%20software%2C%20organized%20filing%20system%2C%20professional%20desk%20workspace%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20minimalist%20background&width=400&height=300&seq=es-ap-ar-processing&orientation=landscape'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Reportes Financieros',
      description: 'Cierres mensuales, trimestrales y anuales con reportes financieros integrales y análisis detallados.',
      image: 'https://readdy.ai/api/search-image?query=Spanish%20financial%20reporting%20workspace%20with%20printed%20reports%2C%20charts%2C%20graphs%2C%20computer%20displaying%20financial%20dashboard%2C%20organized%20documents%2C%20calculator%2C%20professional%20office%20setting%2C%20blue%20and%20white%20theme%2C%20simple%20clean%20background&width=400&height=300&seq=es-financial-reporting&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Gestión de Cumplimiento',
      description: 'Manténgase en cumplimiento con las regulaciones fiscales y requisitos de reportes financieros en todas las plataformas.',
      image: 'https://readdy.ai/api/search-image?query=Spanish%20compliance%20management%20desk%20with%20tax%20forms%2C%20regulatory%20documents%2C%20computer%20showing%20compliance%20software%2C%20organized%20filing%20system%2C%20professional%20workspace%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20minimalist%20background&width=400&height=300&seq=es-compliance-mgmt&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Integración de Sistemas',
      description: 'Integración experta con QuickBooks, Microsoft Business Central, Oracle, SAP y otros sistemas de gestión financiera.',
      image: 'https://readdy.ai/api/search-image?query=Spanish%20system%20integration%20workspace%20with%20multiple%20computer%20screens%20showing%20different%20accounting%20software%20interfaces%2C%20QuickBooks%2C%20Oracle%2C%20SAP%20logos%20visible%2C%20organized%20desk%20setup%2C%20professional%20office%20environment%2C%20blue%20and%20white%20theme%2C%20clean%20background&width=400&height=300&seq=es-system-integration&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Servicios Integrales de Contabilidad
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Desde procesamiento de nómina hasta reportes financieros, manejamos todos los aspectos de su contabilidad 
            con experiencia en plataformas líderes de la industria.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}